import { render, staticRenderFns } from "./transaction-disbursement.vue?vue&type=template&id=5f5927f4&"
import script from "./transaction-disbursement.vue?vue&type=script&lang=js&"
export * from "./transaction-disbursement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports